import { Component, OnInit, HostListener } from '@angular/core';

@Component({
    selector: 'app-header-style-one',
    templateUrl: './header-style-one.component.html',
    styleUrls: ['./header-style-one.component.scss']
})
export class HeaderStyleOneComponent implements OnInit {
    menu = [
        // { title: 'Çalışmalar', route: '/our-works' },
        { title: 'Hizmetler', route: '/services' },
        // { title: 'Ekip', route: '/team' },
        // { title: 'Galeri', route: '/gallery' },
        // { title: 'Blog', route: '/blog' },
        { title: 'Hakkımızda', route: '/about' },
        { title: 'İletişim', route: '/contact' }
    ];
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    constructor() { }

    ngOnInit(): void {
    }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    classApplied2 = false;
    toggleClass2() {
        this.classApplied2 = !this.classApplied2;
    }

    classApplied3 = false;
    toggleClass3() {
        this.classApplied3 = !this.classApplied3;
    }

}